import React, { useState } from 'react';
import PersonInputModal from './PersonInputModal';

const AddHandRail = ({ onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    woodType: 'Käsijohteet',
    handRail_woodType: '',
    handRailModel: '',
    length: '',
    amount: '',
    limit: '',
    isHandRail: true,
    isOther: false,
  });

  const [showPersonModal, setShowPersonModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPersonModal(true);
  };

  const handlePersonConfirm = (name) => {
    onSubmit(formData, name);
    setShowPersonModal(false);
    onClose();
  };

  const handlePersonCancel = () => {
    setShowPersonModal(false);
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-window modal-window--narrow">
        <h2 className="modal-title">Lisää käsijohde</h2>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="modal-form__column">
            <label htmlFor="handRail_woodType-input">Puulaji:</label>
            <input
              id="handRail_woodType-input"
              type="text"
              name="handRail_woodType"
              value={formData.handRail_woodType}
              onChange={handleChange}
              required
              className="modal-input"
            />

            <label htmlFor="handRailModel-input">Malli:</label>
            <input
              id="handRailModel-input"
              type="text"
              name="handRailModel"
              value={formData.handRailModel}
              onChange={handleChange}
              required
              className="modal-input"
            />

            <label htmlFor="length-input">Pituus:</label>
            <input
              id="length-input"
              type="text"
              name="length"
              value={formData.length}
              onChange={handleChange}
              required
              className="modal-input"
            />
          </div>

          <div className="modal-form__column">
            <label htmlFor="limit-input">Varmuusraja:</label>
            <input
              id="limit-input"
              type="text"
              name="limit"
              value={formData.limit}
              onChange={handleChange}
              required
              className="modal-input"
            />

            <label htmlFor="amount-input">Määrä:</label>
            <input
              id="amount-input"
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
              className="modal-input"
            />
          </div>

          <div className="modal-form__actions modal-actions--center">
            <button type="button" onClick={handleCancel} className="btn btn-ghost">
              Peru
            </button>
            <button type="submit" className="btn btn-primary">
              Lisää käsijohde
            </button>
          </div>
        </form>
      </div>

      {showPersonModal && (
        <PersonInputModal onConfirm={handlePersonConfirm} onCancel={handlePersonCancel} />
      )}
    </div>
  );
};

export default AddHandRail;
